import React, { useState, useEffect, useRef } from "react";
import { GrowToFullSize } from "./AnimationLibrary";

const ContactHelp = props => {
	const [helpInfoExpanded, setHelpInfoExpanded] = useState(props.expanded);
	const wrapper = useRef(null);

	const handleExpand = () => {
		if (helpInfoExpanded && props.handleDismiss) {
			props.handleDismiss();
		}
		setHelpInfoExpanded(!helpInfoExpanded);
	};

	useEffect(() => {
		setHelpInfoExpanded(props.expanded);
	}, [props]);

	const useDismissOnOutsideClick = ref => {
		function handleClickOutside(event) {
			if (helpInfoExpanded && ref.current && !ref.current.contains(event.target)) {
				handleExpand();
			}
		}

		useEffect(() => {
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};
		});
	};

	useDismissOnOutsideClick(wrapper);

	const helpInfo = (
		<div ref={wrapper} className="help-content__wrapper visible-flex-column">
			<h3 className="help-heading">Contact the Service Desk</h3>
			<div className="help-info">
				<div className="help-info__area">
					<h4 className="help-info__heading">Faculty, staff and students</h4>
					<ul className="contact-options">
						<li className="contact-option web">
							<a target="_blank" rel="noopener noreferrer" href="https://dartgo.org/techhelp">
								dartgo.org/techhelp
										</a>
						</li>
						<li className="contact-option phone">
							<a href="tel:+603-646-2999">603-646-2999</a>
						</li>
						<li className="contact-option phone">
							<a href="tel:+1-855-764-2485">1-855-764-2485</a><span className="type">{" "}(toll-free)</span>
						</li>
					</ul>
				</div>
				<div className="help-info__area">
					<h4 className="help-info__heading">Alumni</h4>
					<ul className="contact-options">
						<li className="contact-option email">
							<a href="mailto:alumni.help@dartmouth.edu">alumni.help@dartmouth.edu</a>
						</li>
						<li className="contact-option phone">
							<a href="tel:+603-646-3202">603-646-3202</a>
						</li>
					</ul>
				</div>
			</div>
			<button type="button" className="close help-close" aria-label="Close" onClick={handleExpand}>
				&times;
			</button>
		</div>);

	return (
		<div className="contact-help">
			<GrowToFullSize delay={props.delay}>
				<div className="trigger" onClick={handleExpand}>
					<span className="trigger__label">Need Help?</span>
				</div>
				{helpInfoExpanded ? helpInfo : ''}
			</GrowToFullSize>
		</div>
	);
};

export default ContactHelp;
